import { render, staticRenderFns } from "./Benutzer.vue?vue&type=template&id=66ce9982&scoped=true&"
import script from "./Benutzer.vue?vue&type=script&lang=js&"
export * from "./Benutzer.vue?vue&type=script&lang=js&"
import style0 from "./Benutzer.vue?vue&type=style&index=0&id=66ce9982&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66ce9982",
  null
  
)

export default component.exports